import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { ClassesProps } from 'react-jss';
import { Hits } from '../../../../../models/hotel-reviews';
import { highlightingHitsWords } from '../../../../../utils/reviews';
export interface ReviewTextProps {
    negativeFeedback: string;
    positiveFeedback: string;
    positiveHits?: Hits;
    negativeHits?: Hits;
    activeFilterHits: number[];
}

interface StyledReviewTextProps extends ClassesProps, ReviewTextProps { }

export function ReviewText(props: StyledReviewTextProps) {
    const [showMoreBtn, setShowMoreBtn] = useState<boolean>(false);
    const [isShowDetailReviewText, setShowDetailText] = useState(false);
    const { classes, negativeFeedback, positiveFeedback, positiveHits, negativeHits, activeFilterHits } = props;
    const showSubTitle = positiveFeedback && negativeFeedback;
    const isEmptyMessage = !positiveFeedback && !negativeFeedback;
    const reviewRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (reviewRef?.current) {
            if (reviewRef.current.scrollHeight > reviewRef.current.clientHeight) {
                setShowMoreBtn(true);
            }
        }
    }, [positiveFeedback, negativeFeedback, reviewRef]);

    const switchShowText = () => setShowDetailText((st) => !st);

    const positiveSection = () => {
        return (
            <>
                {positiveFeedback && positiveHits && activeFilterHits.length ? (
                    <p
                        className={classes.paragraph}
                        dangerouslySetInnerHTML={{
                            __html: highlightingHitsWords(positiveFeedback, positiveHits, activeFilterHits),
                        }}
                    />
                ) : null}
                {positiveFeedback && !activeFilterHits.length ? (
                    <p className={classes.paragraph}>{positiveFeedback}</p>
                ) : null}
            </>
        );
    };

    const negativeSection = () => {
        return (
            <>
                {negativeFeedback && negativeHits && activeFilterHits.length ? (
                    <p
                        className={classes.paragraph}
                        dangerouslySetInnerHTML={{
                            __html: highlightingHitsWords(negativeFeedback, negativeHits, activeFilterHits),
                        }}
                    />
                ) : null}

                {negativeFeedback && !activeFilterHits.length ?
                    <p className={classes.paragraph}>{negativeFeedback}</p>
                    : null}
            </>
        );
    };

    const renderEmptyReviewPlacholder = () => {
        return (
            <div className={classes.emptyReviewContainer}>
                <p className={classes.emptyParagraph}>Турист не оставил подробную оценку</p>
            </div>
        );
    };

    const renderReviewText = () => {
        return (
            <>
                {showSubTitle && <strong className={classes.subtitle}>Что впечатлило</strong>}
                {positiveSection()}

                {showSubTitle && <strong className={classes.subtitle}>Что огорчило</strong>}
                {negativeSection()}
            </>
        );
    };

    return (
        <>
            <div
                className={`${classes.reviewText} ${isShowDetailReviewText ? classes.reviewTextDetail : ''}`}
                ref={reviewRef}
            >
                {isEmptyMessage ? renderEmptyReviewPlacholder() : renderReviewText()}
            </div>
            {showMoreBtn && (
                <button className={classes.moreInfoButton} onClick={switchShowText} type="button">
                    {isShowDetailReviewText ? 'Свернуть' : 'Читать далее'}
                </button>
            )}
        </>
    );
}
